import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";
import { SignalAIRankReport } from "@/components/rank-tracker/SignalAIRankReport";
import { AsinProductsTable } from "@/components/rank-tracker/AsinProductsTable";
import type { PublicRankTrackerPagePayload } from "@/types";

interface PublicRankTrackerPageViewProps {
  payload: PublicRankTrackerPagePayload;
}

export function PublicRankTrackerPageView({ payload }: PublicRankTrackerPageViewProps) {
  const { brand, generatedAt, filters, aiReport, heroProducts, keywordsByHeroProductId } = payload;

  const generatedDate = format(new Date(generatedAt), "MMM d, yyyy 'at' h:mm a");

  const asinLabels = filters.selectedAsinIds.length > 0
    ? heroProducts
        .filter(p => filters.selectedAsinIds.includes(p.id))
        .map(p => p.asin)
    : heroProducts.map(p => p.asin);

  const dateLabel = filters.customDateRange.from && filters.customDateRange.to
    ? `${format(new Date(filters.customDateRange.from), "MMM d, yyyy")} – ${format(new Date(filters.customDateRange.to), "MMM d, yyyy")}`
    : `Last ${filters.selectedDays} days`;

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-bold text-foreground">Rank Tracker — {brand.name}</h1>
        <p className="text-sm text-muted-foreground">Generated {generatedDate}</p>
      </div>

      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-sm text-muted-foreground font-medium">Snapshot filters:</span>
        <Badge variant="secondary">{dateLabel}</Badge>
        {asinLabels.map(asin => (
          <Badge key={asin} variant="outline" className="font-mono text-xs">{asin}</Badge>
        ))}
      </div>

      {aiReport && (
        <SignalAIRankReport publicData={aiReport} />
      )}

      <AsinProductsTable
        publicData={{ heroProducts, keywordsByHeroProductId }}
      />
    </div>
  );
}
